import React from "react"

import "./background.scss"

export default () => (
  <div className='lined-bg'>
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
)
